import AppLayout from "../layouts/AppLayout";

export default function Contact() {
    return (
        <AppLayout>
            <div className="w-full">
                <article className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-0 flex flex-col">
                    <h1 className="text-3xl font-bold mb-4 text-gray-900">Contact Us</h1>

                    <p className="text-lg text-gray-700 mb-6">
                        We’re always open to hearing from you. Whether you have a question about our platform, a feature suggestion, or a business inquiry — don’t hesitate to reach out.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-2">General Inquiries</h2>
                    <p className="text-gray-700 mb-4">
                        For any general questions, feedback, or suggestions, please email us at <a href="mailto:support@pricehunt.ca" className="text-blue-500 hover:underline">support@pricehunt.ca</a>.
                    </p>

                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Business & Partnerships</h2>
                    <p className="text-gray-700 mb-4">
                        Interested in collaborating with PriceHunt.ca? Contact us at <a href="mailto:partnerships@pricehunt.ca" className="text-blue-500 hover:underline">partnerships@pricehunt.ca</a> to discuss partnership opportunities.
                    </p>

                    {/* <h2 className="text-xl font-semibold text-gray-800 mb-2">Social Media</h2>
                    <p className="text-gray-700 mb-4">
                        Follow us on social media to stay updated:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 mb-4">
                        <li><a href="#" className="text-blue-500 hover:underline">Twitter</a></li>
                        <li><a href="#" className="text-blue-500 hover:underline">Instagram</a></li>
                        <li><a href="#" className="text-blue-500 hover:underline">LinkedIn</a></li>
                    </ul> */}

                    <h2 className="text-xl font-semibold text-gray-800 mb-2">Response Time</h2>
                    <p className="text-gray-700">
                        We aim to respond to all inquiries within 1-2 business days.
                    </p>
                </article>
            </div>
        </AppLayout>
    )
}
